import React from 'react'
import {motion} from "framer-motion"
import './AboutDhonus.css'

function AboutDhonus() {
  return (
 <div className="AboutDhonusContainer">
      {/* Title Animation */}
      <motion.h2
        className="AboutDhonustitle"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1,
          ease: "easeOut",
        }}
        viewport={{ once: true }}
      >
        About House of Dhanushdhari
      </motion.h2>

      {/* Paragraph Animation */}
      <motion.p
        className="AboutDhonusPara"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          duration: 1.2,
          delay: 0.3,
          ease: "easeOut",
        }}
        viewport={{ once: true }}
      >
        Your Trusted Real Estate Partner in Kalyani & Halisahar
        <br />
        At Dhanushdhari Developers, we offer premium apartments and properties
        in Kalyani and Halisahar — directly from the developer, with no agents
        or brokers involved.
        <br />
        We focus on quality construction, transparent deals, and customer
        satisfaction, ensuring you get the best value for your dream home.
        <br />
        Choose Dhanushdhari Developers — where trust, comfort, and modern
        living come together.
      </motion.p>

      {/* Divider Line Animation */}
      <motion.hr
        style={{ backgroundColor: "black", height: "2px", border: "none" }}
        initial={{ width: 0, opacity: 0 }}
        whileInView={{ width: "80%", opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        viewport={{ once: true }}
      />
    </div>
  )
}

export default AboutDhonus